import React from "react";
import {
    Slide,
    Paper,
    Divider,
    ButtonGroup,
    Button,
    Box,
    TextField,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router";
import { connect, useSelector } from "react-redux";
import { ApplicationState } from "../store";
import * as APIStore from "../store/APIStore";
import { useRouteMatch } from "react-router-dom";
import { Reply, Forward, Delete, Send, Cancel } from "@material-ui/icons";
import ConfirmDialog from "./ConfirmDialog";
import { useHistory } from "react-router-dom";
import RequestAccessToken from "../util/authService";
import NotificationPatient from "./notification/NotificationPatient";
import { DetailedPatientStateType } from './notification/MessagePatientLoadState';


import Hidden from '@material-ui/core/Hidden';
import './style.css';
import { refMDLoaded, practiceCoordinatorLoaded, shouldTryRefMDProfile, shouldTryCareCoordinatorProfile } from './common/ProfileHelper'


type NotificationItemReply = APIStore.HNIContextState &
    typeof APIStore.actionCreators &
    RouteComponentProps<{ MessageId: string }>;

const makeReplyMessage = (
    orginalMessage: APIStore.Message,
    userId: string
): APIStore.Message => {
    let ret: APIStore.Message = {
        ...orginalMessage,
        senderId: userId,
        receiverId: orginalMessage.senderId,
        subject: `RE ${orginalMessage.subject}`,
    };

    return ret;
};

const NotificationReply = (props: NotificationItemReply) => {
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const initialMessageState: APIStore.Message = {};
    const [replyMessageState, setReplyMessageState] =
        useState(initialMessageState);
    let {
        location,
        Messages,
        submitReplyMessage,
        archiveMessage,
        requestConsolidatedPatientById,
        Patients,
        FocusPatient
    } = props;

    let userPracticeCoordinatorProfile = props.userPracticeCoordinatorProfile;
    let userRefMdProfile = props.userRefMdProfile;
    let { state } = location;
    let { message } = state;

    let { SendMessageState } = Messages;

    let initial: DetailedPatientStateType = {
        patient: undefined,
        isLoaded: false,
        isLoading: false
    };

    let [detailedPatientState, setDetailedPatientState] = useState<DetailedPatientStateType>(initial);

    let [tokenState, setTokenState] = useState<APIStore.TokenType>(null);

    let tokenStatePr = RequestAccessToken().then((token) => {
        if (token && !tokenState) {
            setTokenState(token);
        }
    });

    useEffect(() => {
        if (message?.messageId) {
            if (practiceCoordinatorLoaded(userPracticeCoordinatorProfile)) {
                setReplyMessageState(makeReplyMessage(message, userPracticeCoordinatorProfile.coordinatorProfile?.azureAdAccount));
            } else if (refMDLoaded(userRefMdProfile)) {
                setReplyMessageState(makeReplyMessage(message, userRefMdProfile.refmdProfile?.email));
            }

        }
    }, [message]);



    useEffect(() => {
        if (message?.messageId) {
            let patientEncounterId = message?.ptId;
            if (tokenState?.accessToken && !detailedPatientState?.isLoaded && !detailedPatientState.isLoading) {
                requestConsolidatedPatientById(patientEncounterId, tokenState.accessToken);
                setDetailedPatientState({
                    ...detailedPatientState,
                    isLoading: true
                })
            }


            if (detailedPatientState.isLoading) {
                if (FocusPatient?.patient?.patientEncounterId) {
                    setDetailedPatientState({ isLoaded: true, isLoading: false, patient: FocusPatient?.patient });
                }
            }
        }

    }, [tokenState, detailedPatientState, Patients.fullPatients, message]);

    const handleMessageChange = (e: any) => {
        setReplyMessageState({
            ...replyMessageState,
            Message: e.target.value
        });
    };
    const handleSubmit = () => {
        submitReplyMessage(replyMessageState, tokenState.accessToken);
        goBack();
    };

    const handleDelete = () => {
        archiveMessage(replyMessageState, tokenState.accessToken);
        setDeleteDialogOpen(true);
    };

    const handleClose = () => {
        archiveMessage(replyMessageState, tokenState.accessToken);
        setDeleteDialogOpen(false);
    };

    const history = useHistory();
    const goBack = () => {
        history.goBack();
    };

    if (!replyMessageState?.messageId || !detailedPatientState?.isLoaded) {
        return <></>;
    }

    let statusStr = '';
    if (SendMessageState && SendMessageState.isErrored) {
        statusStr = SendMessageState.error;
    }
    if (SendMessageState && SendMessageState.isSent) {
        statusStr = `Message Sent ${SendMessageState.message.messageId}`
    }


    return (

        <div className="maincontent">
                <ConfirmDialog
                    id="delete-notificaiton-item"
                    keepMounted
                    open={deleteDialogOpen}
                    onClose={handleClose}

                    question="Are you sure you want to Delete?"
                    title="Confirm Delete"
                />

                <Grid container spacing={12} className="noticebar">
                    <Grid item>
                        <Button onClick={handleSubmit} startIcon={< Send />} >
                            <Hidden xsDown>Send</Hidden>
                        </Button>
                        <Button onClick={goBack} startIcon={< Cancel />} >
                            <Hidden xsDown>Cancel</Hidden>
                        </Button>
                    </Grid>
                </Grid>
                <Box m={4}>
                    <Grid container direction="row" spacing={4}>
                        <Grid item xs={12}>
                            {`${new Date()}`}<br /><br />
                            <div>To: <strong>{`${replyMessageState.receiverId}`}</strong></div>
                            <div>From: <strong>{`${replyMessageState.senderId}`}</strong></div>
                            <div>Subject: <strong>{`${replyMessageState.subject}`}</strong></div>
                            <br/>
                            <NotificationPatient message = {replyMessageState}/>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                id="outlined-multiline-static"
                                label="Reply"
                                multiline
                                onChange={handleMessageChange}
                                rows={4}
                                value={replyMessageState.Message}
                                defaultValue=""
                                variant="outlined"
                            />
                        </Grid>
                        
                    </Grid>
                </Box>
            </div>
    );
};

export default connect(
    (state: ApplicationState) => state.vitalsContext,
    APIStore.actionCreators
)(NotificationReply as any);
